import gql from 'graphql-tag';

export default gql`
  mutation(
    $publicationUrl: URI!
    $suggestionsListId: ID!
    $loans: Int!
    $libraries: Int!
  ) {
    addMissingPopularSuggestion(
      input: {
        publicationUrl: $publicationUrl
        suggestionsListId: $suggestionsListId
        libraryComment: ""
        loans: $loans
        libraries: $libraries
      }
    ) {
      code
    }
  }
`;
